
$(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip();
  filterEventsOnLocationSelection();
  filterEventsOnTypeSelection();

  enableChosenSelects($(':root'))
  submitSearchForm()
  selectAllEventUnits();
  toggleIndividualEventUnits();

  $(document).on('change', '#q_id_eq', function() {
    submitSearchFormOnChange();
  })

  $(document).on('change', '#q_event_units_country_id_eq', function() {
    submitSearchFormOnChange();
  })

  $(document).on('change', '#sort_date', function() {
    submitSearchFormOnChange();
  })

});

$(document).on('turbolinks:load', function() {
  $('[data-toggle="tooltip"]').tooltip();
  filterEventsOnLocationSelection();
  filterEventsOnTypeSelection();
  selectAllEventUnits();
  toggleIndividualEventUnits();
  submitSearchForm();
  enableChosenSelects($(':root'));

  $(document).on('change', '#q_id_eq', function() {
    submitSearchFormOnChange();
  })
  $(document).on('change', '#q_event_units_country_id_eq', function() {
    submitSearchFormOnChange();
  })

  $(document).on('change', '#sort_date', function() {
    submitSearchFormOnChange();
  })

  $(document).on('change', '#q_start_at_on_gteq', function(){
    $('#q_end_at_on_lteq').attr('min', $(this).val());
  })

  $(document).on('change', '#q_end_at_on_lteq', function(){
    $('#q_start_at_on_gteq').attr('max', $(this).val());
  })

});

function submitSearchFormOnChange() {
  var input = $('.ransack_search_form').find('form');
  input.submit();
}

function enableChosenSelects ($root) {
  var selectOptions = {
    no_results_text: 'Oops, nothing found!',
    width: '100%',
    search_contains: true
  }

  $root.find('.chosen-select').chosen(selectOptions)

  $root.find('.chosen-select-deselect').chosen(
    Object.assign({ allow_single_deselect: true }, selectOptions)
  )
}

function submitSearchForm() {
  var input = $('.ransack_search_form').find('form');
  var search_value = $('.ransack_search_form').find('form').find('#q_name_cont').val();

  input.find('.fa-search').on('click', function() {
    if($('.ransack_search_form').find('form').find('#q_name_cont').val()) {
      input.submit();
    }
  });

  input.on('keypress', function(e) {
    if(e.which == 10 || e.which == 13) {
      if($('.ransack_search_form').find('form').find('#q_name_cont').val()) {
        input.submit();
      }
    }
  });
}

function filterEventsOnLocationSelection() {
  $("[id$=q_event_units_city_eq]").on('click', function() {
    if ($(this).is(":checked")){
      if($(this).val() == 'all') {
        $("[id$=q_event_units_city_eq]").prop('checked', true)
      }
    } else {
      if($(this).val() == 'all') {
        $("[id$=q_event_units_city_eq]").prop('checked', false)
      } else {
        $('.all_location').prop('checked', false);
      }
    }
    $('.filter_form').submit();
  })

}

function filterEventsOnTypeSelection(){
  $("[id$=q_event_type_id_eq]").on('click', function() {
    if ($(this).is(":checked")){
      if($(this).val() == 'all') {
        $("[id$=q_event_type_id_eq]").prop('checked', true);
      }
    } else {
      if($(this).val() == 'all') {
        $("[id$=q_event_type_id_eq]").prop('checked', false);
      } else {
        $('.all_event_type').prop('checked', false);
      }
    }
    $('.filter_form').submit();
  })
}

function selectAllEventUnits() {
  $('#select_all_event_units').on('click', function(){
    if ($(this).is(":checked")){
      $("[id$=event_unit_select]").prop('checked', true);
      toggleCartInput("[id^=cart_row]", false)
      $("[id^=cart_row]").removeClass('d-none');
      calculateGrandTotal();
    } else {
      $("[id$=event_unit_select]").prop('checked', false);
      toggleCartInput("[id^=cart_row]", true)
      $("[id^=cart_row]").addClass('d-none');
      calculateGrandTotal();
    }
  })
}

function toggleIndividualEventUnits() {
  $("[id$=event_unit_select]").on('click', function(){
    let unit_id = $(this).val();
    let unit_selector = '#cart_row_' + unit_id;
    if ($(this).is(":checked")){
      $(unit_selector).removeClass('d-none');
      toggleCartInput(unit_selector, false)
      calculateGrandTotal();
    } else {
      $(unit_selector).addClass('d-none');
      $("#select_all_event_units").prop('checked', false);
      toggleCartInput(unit_selector, true);
      calculateGrandTotal();
    }
  })
}

function toggleCartInput(selector, value) {
  $(selector).find('td:nth-child(3)').find('.event_price').prop('disabled', value)
  $(selector).find('td:nth-child(4)').find('.cartable_id').prop('disabled', value)
  $(selector).find('td:nth-child(5)').find('.cartable_type').prop('disabled', value)
  $(selector).find('td:nth-child(6)').find('.destroy_label').val(value)
}

function calculateGrandTotal() {
  var total = 0;
  var value;
  $.each($('.event_cart').find('.event_price'), function(index, formField) {
    if(formField.disabled) {
      value = 0.0;
    } else {
      value = isNaN(parseFloat(formField.value)) ? 0 : parseFloat(formField.value)
    }
    total = total + value
  });
  $('.total_cart_value').text("$" + total.toFixed(2));
}
$( document ).on('turbolinks:load', function() {
  $('.mob-filter-btn').click(function() {
    $(".mob-filter").toggle();
  });
  $('.close-btn').click(function() {
    $(".mob-filter").toggle();
  });
});
